import React, { useRef, useState, lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import useWindowsSize from "@/Hooks/useWindowsSize";
import useDessableZoom from "@/Hooks/useDesableZoom";
import {
  DetailImageKnowMore,
  HeaderKnowMoreWeb,
  HeaderKnowMoreMovil,
  NavMovil,
} from "@/Components/Index";
//css
import "@/Styles/CarouselConfig.css";
import { useConfigInfo } from "@/Service/Api/ApiKnowMore/KnowMore";

const LazyHeaderWeb = lazy(() => import("@/Components/Header/HeaderWeb"));
const LazyHeaderMovil = lazy(() => import("@/Components/Header/HeaderMovil"));

const Details: React.FC = () => {
  const { width } = useWindowsSize();
  const { knowMore, isLoading } = useConfigInfo();
  // current
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  // refs para swipe táctil
  const carouselRef = useRef<HTMLDivElement | null>(null);
  const touchEndXRef = useRef<number>(0);
  const touchStartXRef = useRef<number>(0);

  // urls
  const electronic = "/Electrónica";

  // deshabilitamos el zoom
  useDessableZoom();

  //********** variables reutilizables **********\\
  const styles = {
    height: width < 1200 ? "60%" : "50%",
  };

  const stylesv2 = {
    height: "40%",
  };

  const styleFontSizeOmitir = {
    fontSize: width >= 1080 ? "26px" : "20px",
  };

  const styleOmitir = {
    marginTop: width >= 1080 && width < 1200 ? "5%" : "1%",
  };

  const styleHeight = {
    height: width >= 950 ? "60%" : "65%",
  };

  const styleHeight1 = {
    height: width >= 950 ? "40%" : "35%",
  };

  const styleColumns = { height: "95vh" };

  // Función para ir al siguiente slide
  const nextSlide = () => {
    const totalKnowMore = Array.isArray(knowMore) ? knowMore.length : 0;
    if (currentSlide < totalKnowMore - 1) setCurrentSlide(currentSlide + 1);
  };

  const anteriorOrPorteriorSide = (x: number) => setCurrentSlide(x);

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    touchStartXRef.current = e.touches[0]?.clientX ?? 0;
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    touchEndXRef.current = e.touches[0]?.clientX ?? 0;
  };

  const handleTouchEnd = () => {
    const touchDiff = touchStartXRef.current - touchEndXRef.current;
    if (touchDiff > 50) nextSlide(); // izquierda
    else if (touchDiff < -50 && currentSlide > 0)
      setCurrentSlide(currentSlide - 1); // derecha
  };

  const carrouselImg = (): JSX.Element => (
    <div
      className={`w-100
        ${
          width < 1200
            ? "carousel-container-developMX"
            : width >= 1300
            ? "carousel-container-developArgV2"
            : "carousel-container-developArg"
        }
      `}
      ref={carouselRef}>
      <div
        className="carousel-slides"
        style={{
          transform: `translateX(-${currentSlide * 100}%)`,
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}>
        {knowMore?.map((slide) => (
          <div className="carousel-slide" key={slide.Id}>
            <img src={slide.ImagenPath} alt={String(slide?.Id) ?? "Imagen"} />
          </div>
        ))}
      </div>
      {spanImagenesCirculo()}
    </div>
  );

  const spanImagenesCirculo = (): JSX.Element => (
    <div className="carousel-dots">
      {knowMore?.map((_, index) => (
        <span
          key={index}
          className={`dot ${currentSlide === index ? "active" : ""}`}
          onClick={() => anteriorOrPorteriorSide(index)}></span>
      ))}
    </div>
  );

  const handdleSkeleton = (): JSX.Element => (
    <div
      className={`w-100
      ${
        width < 1200
          ? "carousel-container-developMX"
          : width >= 1300
          ? "carousel-container-developArgV2"
          : "carousel-container-developArg"
      }
    `}>
      <div className="w-100 skeleton-developArg d-flex justify-content-center text-center">
        <div className="w-100 align-self-center">
          <div className="carousel-slide">
            <span
              className={`${
                width >= 1080 ? "display-1" : "display-2"
              } text-white`}>
              Cargando ...
            </span>
          </div>
        </div>
      </div>
    </div>
  );

  const handdleSkeletonInfoImage = (): JSX.Element => (
    <div className="p-2 mt-2 d-flex flex-column classInfo__developMX">
      <div className="p-2 mb-3">
        <span className="develop___ColorText develop__fontFamilys__titles develop__text__info">
          <Skeleton className="skeleton-infoImage-develop" />
        </span>
      </div>
    </div>
  );

  const btnSiguienteImagenInfo = (): JSX.Element => (
    <div className="carousel-controls">
      {isLoading ? (
        <Skeleton
          className={
            width >= 1080
              ? "btn-develop-skeleton p-3"
              : "btn-develop-skeletonV2"
          }
        />
      ) : knowMore ? (
        currentSlide < knowMore.length - 1 ? (
          <button
            className={
              width >= 1080 ? "develop__btn__red" : "develop__btn__redV2"
            }
            onClick={nextSlide}>
            Siguiente
          </button>
        ) : (
          <Link
            to={electronic}
            className={
              width >= 1080 ? "develop__btn__red" : "develop__btn__redV2"
            }
            onClick={nextSlide}>
            Siguiente
          </Link>
        )
      ) : null}
    </div>
  );

  const btnOmitir = (): JSX.Element => (
    <div className="p-2 text-center">
      {isLoading ? (
        <Skeleton className="p-4 btn btn-develop-omitir-skeleton" />
      ) : (
        knowMore && (
          <Link
            to={electronic}
            className="btn develop___ColorTextOmitir"
            style={styleFontSizeOmitir}>
            Omitir
          </Link>
        )
      )}
    </div>
  );

  const handdleNewView = (): JSX.Element => (
    <div className="w-100 d-flex flex-column">
      <div className="w-100" style={styleHeight}>
        {isLoading ? (
          handdleSkeletonInfoImage()
        ) : (
          <DetailImageKnowMore
            knowMore={Array.isArray(knowMore) ? knowMore : []}
            currentSlide={currentSlide}
          />
        )}
      </div>
      <div
        className={`w-100 d-flex justify-content-center ${
          width >= 950 ? "" : "mt-2"
        }`}
        style={styleHeight1}>
        <div className="w-100 align-self-center">
          {btnSiguienteImagenInfo()}
          {width >= 400 && (
            <div className="p-2 w-100" style={styleOmitir}></div>
          )}
          {btnOmitir()}
        </div>
      </div>
    </div>
  );

  return (
    <Suspense>
      {width > 1200 ? (
        <LazyHeaderWeb>
          <HeaderKnowMoreWeb
            titleCategoria={"Pasillos Infinitos"}
            toLink={"/"}
            toInicio={1}
          />
        </LazyHeaderWeb>
      ) : (
        <LazyHeaderMovil>
          <NavMovil classNames={"aling-self-center"}>
            <HeaderKnowMoreMovil titleCategoria={"Pasillos Infinitos"} />
          </NavMovil>
        </LazyHeaderMovil>
      )}
      <div className="container-full">
        <div className="d-flex flex-column" style={styleColumns}>
          <div
            className={`w-100 d-flex justify-content-center text-center ${
              width > 1200 ? "mt-4" : ""
            }`}
            style={styles}>
            <div className="w-75 d-flex justify-content-center align-self-end">
              {isLoading ? handdleSkeleton() : carrouselImg()}
            </div>
          </div>
          <div
            className="w-100 d-flex justify-content-center text-center"
            style={stylesv2}>
            {handdleNewView()}
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default Details;
